module.exports = __webpack_public_path__ + "assets/img/part1.9b53c2e1.png";